import { render, staticRenderFns } from "./students_archive.vue?vue&type=template&id=0a852af1&"
import script from "./students_archive.vue?vue&type=script&lang=js&"
export * from "./students_archive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports